<template>
  <div id="Page3" class="home">
    <div class="banner">
      <img src="@/assets/img/PG3-1-952x400.png" alt="" />
    </div>
    <div class="bannerBtmLine">
      <div class="leftLine"></div>
      <div class="rightLine"></div>
    </div>
    <div class="mainTop">
      <span class="Breadcrumb">
        <router-link to="/">{{ $t("Homepage") }}</router-link> >
        {{ $t("Travel") }}</span
      >
      <div class="topLine"></div>
    </div>
    <div class="main">
      <div class="Introduction">
        <div class="content">
          <h2>{{ $t("PG3T") }}</h2>
          <span>―</span>
          <p v-for="i in 5" :key="i" :class="{ first: i === 1 }">
            {{ $t(`PG3P${i}`) }}
          </p>
          <div class="photo">
            <img src="@/assets/img/PG3-2-311x208.png" alt="" />
            <img src="@/assets/img/PG3-3-311x208.png" alt="" />
          </div>
        </div>
      </div>

      <GameList />
    </div>
  </div>
</template>

<script>
export default {
  name: "Page4",
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;

  .main {
    .Introduction {
      display: flex;
      justify-content: flex-end;
      padding: 48px;
      .content {
        color: #d7af21;
        width: 80%;
        padding: 0 16px;
        h2 {
          font-size: 28px;
        }
        span {
          display: block;
          font-size: 26px;
          padding-bottom: 16px;
        }
        .first:first-letter {
          font-size: 26px;
          text-transform: uppercase;
        }
        p {
          font-size: 18px;
          line-height: 24px;
          padding-bottom: 16px;
          letter-spacing: 1px;
        }
        .photo {
          display: flex;
          img {
            box-sizing: border-box;
            width: 50%;
            padding: 8px;
          }
        }
      }
    }
  }
}
</style>
